import Form from "../components/Form";
import React, { useState, useEffect, useRef } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { Checkbox } from "@mui/material";
import { useLocation } from "react-router-dom";
import axios from "axios";

function Charity() {
  const [donationAmount, setDonationAmount] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [payment, setPayment] = React.useState("creditCard");
  const [receiptRequested, setReceiptRequested] = useState(false);
  const phoneInputRef = useRef(null);
  const [articleContent, setArticleContent] = useState({});
  let location = useLocation();

  useEffect(() => {
    const phoneInput = phoneInputRef.current;
    let searchParams = new URLSearchParams(location.search);
    let path = searchParams.get("path");

    axios
      .post("/api/website/getPage", { pagePath: path })
      .then((response) => {
        const pageData = response.data.data.result;
        document.title = pageData.title;
        setArticleContent(pageData);
      })
      .catch((error) => {
        console.error("Error fetching article content:", error);
      });

    if (phoneInput) {
      const inputListener = (e) => {
        e.target.value = e.target.value.replace(/\D/g, "").slice(0, 10);
      };
      phoneInput.addEventListener("input", inputListener);

      return () => {
        phoneInput.removeEventListener("input", inputListener);
      };
    }
  }, [location.search]);

  const validateForm = () => {
    return donationAmount && name && phone;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      alert("請填寫完整的捐款資訊");
      return;
    }

    if (receiptRequested) {
      const receiptAddress = document.getElementById("receiptAddress").value;
      const receiptName = document.getElementById("receiptName").value;
      const receiptPhone = document.getElementById("receiptPhone").value;

      if (!receiptAddress || !receiptName || !receiptPhone) {
        alert("請填寫完整的收據資訊");
        return;
      }
    }

    const donationData = {
      id: 1,
      amount: parseInt(donationAmount, 10),
      name: name,
      phone: phone,
    };

    let apiUrl = "/api/homepage/donate";

    if (payment === "bankTransfer") {
      apiUrl = "/api/homepage/donate/atm";
    }

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(donationData),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const htmlContent = await response.text();
      handlePaymentSubmit(htmlContent);
    } catch (error) {
      console.error("Error submitting donation:", error);
    }
  };

  const handleSetAmount = (amount) => {
    setDonationAmount(parseInt(amount, 10));
  };

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handlePhoneChange = (e) => {
    const numericValue = e.target.value.replace(/\D/g, "");
    setPhone(numericValue);
  };

  const handleAmountChange = (e) => {
    const numericValue = e.target.value.replace(/\D/g, "");
    setDonationAmount(numericValue);
  };

  const handlePaymentSubmit = (htmlContent) => {
    const paymentWindow = window.open("", "_blank");

    if (paymentWindow) {
      paymentWindow.document.write(htmlContent);

      const form = paymentWindow.document.querySelector("form");
      if (form) {
        form.submit();
      }
    } else {
      alert("無法開新視窗，請檢察瀏覽器設定。");
    }
  };

  const handleChange = (e) => {
    setPayment(e.target.value);
  };

  return (
    <main className="relative">
      <section className="h-[250px] m-auto pt-[90px] page-title">
        <div className="text-center mb-[44px]">
          <h2 className="text-[#3D3D3D] font-normal text-5xl mb-[15px]">慈善捐款</h2>
          <h3 className="text-[#696969] font-normal text-xl" style={{ color: "#ff6b2b" }}>
            Charity Donation
          </h3>
        </div>
      </section>
      <section className="flex gap-10 max-w-7xl m-auto mt-24 mb-20 md-l:flex-col">
        <div className="m-auto max-w-[700px] leading-loose text-[#373737]">
          <div className="border-l-8 border-[#FF6B2B] pl-3 mb-14">
            <h2 className="text-5xl text-[#3D3D3D] mb-2">{articleContent.title}</h2>
            <h3 className="text-2xl text-[#FF6B2B]">Introduction</h3>
          </div>
          <div dangerouslySetInnerHTML={{ __html: articleContent.content }}></div>
        </div>
        <div className="max-w-[580px] md-l:m-auto">
          <div className=" bg-[#FFF4DA] rounded-xl p-9 sticky top-[120px]">
            <p className="text-3xl font-extrabold mb-7">是的！我願意盡一薄之力！</p>
            <p className="mb-11">感謝有你的善心捐款，讓我們將愛傳播到世界各地！</p>
            <p className="text-xl mb-3">選擇金額</p>
            <div className="flex gap-3 mb-9">
              <button
                onClick={() => handleSetAmount(300)}
                className="w-40 h-28 bg-[#FFE8B4] rounded-md text-4xl font-bold hover:bg-[#FF8947] hover:text-[#FFF]"
              >
                300 <br />
                <span className="text-sm font-normal">新臺幣</span>
              </button>
              <button
                onClick={() => handleSetAmount(600)}
                className="w-40 h-28 bg-[#FFE8B4] rounded-md text-4xl font-bold hover:bg-[#FF8947] hover:text-[#FFF]"
              >
                600 <br />
                <span className="text-sm font-normal">新臺幣</span>
              </button>
              <button
                onClick={() => handleSetAmount(800)}
                className="w-40 h-28 bg-[#FFE8B4] rounded-md text-4xl font-bold hover:bg-[#FF8947] hover:text-[#FFF]"
              >
                800 <br />
                <span className="text-sm font-normal">新臺幣</span>
              </button>
            </div>
            <div className="mb-4">
              <label htmlFor="" className="mr-2 text-xl">
                新臺幣
              </label>
              <input
                type="text"
                className="bg-[#FFE8B4] placeholder:text-[#C4B48E] rounded-md py-3 px-4 w-[416px] h-12 mb-3"
                placeholder="其他金額"
                required
                value={donationAmount}
                onChange={handleAmountChange}
              />
              <br />
              <label htmlFor="" className="mr-2 text-xl">
                姓名
              </label>
              <input
                type="text"
                className="bg-[#FFE8B4] placeholder:text-[#C4B48E] rounded-md py-3 px-4 w-[436px] h-12 mb-3"
                placeholder="請輸入姓名"
                required
                title="請填寫姓名"
                value={name}
                onChange={handleNameChange}
              />
              <br />
              <label htmlFor="" className="mr-2 text-xl">
                電話
              </label>
              <input
                type="text"
                ref={phoneInputRef}
                className="bg-[#FFE8B4] placeholder:text-[#C4B48E] rounded-md py-3 px-4 w-[436px] h-12"
                placeholder="請輸入電話"
                required
                title="請填寫電話"
                value={phone}
                maxLength="10"
                onChange={handlePhoneChange}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={receiptRequested}
                    onChange={(e) => setReceiptRequested(e.target.checked)}
                  />
                }
                label="我要收據"
                className="mt-4"
              />
              {receiptRequested && (
                <div>
                  <label htmlFor="receiptAddress" className="mr-2 text-xl">
                    寄送地址
                  </label>
                  <input
                    type="text"
                    id="receiptAddress"
                    className="bg-[#FFE8B4] placeholder:text-[#C4B48E] rounded-md py-3 px-4 w-[396px] h-12 mb-3"
                    placeholder="請輸入地址"
                    title="請填寫地址"
                    required
                  />
                  <br />
                  <label htmlFor="receiptName" className="mr-2 text-xl">
                    收件姓名
                  </label>
                  <input
                    type="text"
                    id="receiptName"
                    className="bg-[#FFE8B4] placeholder:text-[#C4B48E] rounded-md py-3 px-4 w-[396px] h-12 mb-3"
                    placeholder="請輸入姓名"
                    title="請填寫姓名"
                    required
                  />
                  <br />
                  <label htmlFor="receiptPhone" className="mr-2 text-xl">
                    收件電話
                  </label>
                  <input
                    type="text"
                    id="receiptPhone"
                    className="bg-[#FFE8B4] placeholder:text-[#C4B48E] rounded-md py-3 px-4 w-[396px] h-12"
                    placeholder="請輸入電話"
                    pattern="[0-9]{10}"
                    title="請填寫電話"
                    required
                    onChange={handlePhoneChange}
                  />
                </div>
              )}
              <br />
              <FormControl>
                <label htmlFor="" className="mr-2 text-xl mt-4">
                  捐款方式
                </label>
                <RadioGroup
                  row
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="controlled-radio-buttons-group"
                  value={payment}
                  onChange={handleChange}
                >
                  <FormControlLabel value="creditCard" control={<Radio />} label="信用卡" />
                  <FormControlLabel value="bankTransfer" control={<Radio />} label="銀行轉帳" />
                </RadioGroup>
              </FormControl>
            </div>
            <p className="text-base leading-relaxed mb-5">
              小小貢獻是弱勢朋友一整年的支持，
              邀您捐出一日所得，一次讓全台百萬弱勢族群得到專業照護！
            </p>
            <button
              onClick={handleSubmit}
              className="w-[511px] h-[70px] bg-[#FF4747] rounded-md text-xl text-[#FFF] hover:bg-opacity-80"
            >
              我要捐款
            </button>
          </div>
        </div>
      </section>
      <Form />
    </main>
  );
}

export default Charity;
